import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import RoastProfiles from "@/pages/RoastProfiles";
import Imports from "@/pages/Imports";
import Origins from "@/pages/Origins";
import Suppliers from "@/pages/Suppliers";
import Machines from "@/pages/Machines";
import Operators from "@/pages/Operators";
import Users from "@/pages/Users";
import GreenInventory from "@/pages/GreenInventory";
import InventoryForecast from "@/pages/InventoryForecast";
import Blends from "@/pages/Blends";
import MonthlyCosts from "@/pages/MonthlyCosts";
import Equipment from "@/pages/Equipment";
import ManufacturingCost from "@/pages/ManufacturingCost";
import ItemMapping from "@/pages/ItemMapping";
import Roles from "@/pages/Roles";
import Cupping from "@/pages/Cupping";
import ScorecardPrint from "@/pages/ScorecardPrint";
import CuppingReport from "@/pages/CuppingReport";
import Settings from "@/pages/Settings";
import Bills from "@/pages/Bills";
import Journals from "@/pages/Journals";
import MonthlyReport from "@/pages/MonthlyReport";
import MonthlyReportSetup from "@/pages/MonthlyReportSetup";
import SalesTargets from "@/pages/SalesTargets";
import WeeklyRoastReport from "@/pages/WeeklyRoastReport";
import MyRoast from "@/pages/MyRoast";
import Maintenance from "@/pages/Maintenance";
import IntegrationsAdmin from "@/pages/IntegrationsAdmin";
import { ForgotPassword, ForgotEmail, ResetPassword } from "@/pages/AccountFlows";

function Shell({ children, module }) {
  return (
    <ProtectedRoute module={module}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password"  element={<ForgotPassword />} />
          <Route path="/forgot-email"     element={<ForgotEmail />} />
          <Route path="/reset-password"   element={<ResetPassword />} />
          <Route path="/set-password"     element={<ResetPassword />} />
          <Route path="/"               element={<Shell module="dashboard"><Dashboard /></Shell>} />
          <Route path="/roasts"         element={<Shell module="roasts"><RoastProfiles /></Shell>} />
          <Route path="/imports"        element={<Shell module="imports"><Imports /></Shell>} />
          <Route path="/inventory"      element={<Shell module="inventory"><GreenInventory /></Shell>} />
          <Route path="/inventory-forecast" element={<Shell module="inventory"><InventoryForecast /></Shell>} />
          <Route path="/blends"         element={<Shell module="blends"><Blends /></Shell>} />
          <Route path="/cupping"        element={<Shell module="cupping"><Cupping /></Shell>} />
          <Route path="/cupping/:id"    element={<Shell module="cupping"><Cupping /></Shell>} />
          <Route path="/cupping/:id/scorecard" element={<ProtectedRoute module="cupping"><ScorecardPrint /></ProtectedRoute>} />
          <Route path="/cupping/:id/report" element={<ProtectedRoute module="cupping"><CuppingReport /></ProtectedRoute>} />
          <Route path="/monthly-costs"  element={<Shell module="monthly_costs"><MonthlyCosts /></Shell>} />
          <Route path="/equipment"      element={<Shell module="equipment"><Equipment /></Shell>} />
          <Route path="/manufacturing-cost" element={<Shell module="manufacturing_cost"><ManufacturingCost /></Shell>} />
          <Route path="/item-mapping"   element={<Shell module="item_mapping"><ItemMapping /></Shell>} />
          <Route path="/roles"          element={<Shell module="users"><Roles /></Shell>} />
          <Route path="/origins"        element={<Shell module="origins"><Origins /></Shell>} />
          <Route path="/suppliers"      element={<Shell module="suppliers"><Suppliers /></Shell>} />
          <Route path="/machines"       element={<Shell module="machines"><Machines /></Shell>} />
          <Route path="/operators"      element={<Shell module="operators"><Operators /></Shell>} />
          <Route path="/users"          element={<Shell module="users"><Users /></Shell>} />
          <Route path="/settings"       element={<Shell module="settings"><Settings /></Shell>} />
          <Route path="/bills"          element={<Shell module="bills"><Bills /></Shell>} />
          <Route path="/journals"       element={<Shell module="journals"><Journals /></Shell>} />
          <Route path="/monthly-report"       element={<Shell module="monthly_report"><MonthlyReport /></Shell>} />
          <Route path="/monthly-report/setup" element={<Shell module="monthly_report"><MonthlyReportSetup /></Shell>} />
          <Route path="/sales-targets"  element={<Shell module="sales_targets"><SalesTargets /></Shell>} />
          <Route path="/weekly-roast-report" element={<Shell module="roasts"><WeeklyRoastReport /></Shell>} />
          <Route path="/myroast"         element={<Shell module="roasts"><MyRoast /></Shell>} />
          <Route path="/maintenance"     element={<Shell module="roasts"><Maintenance /></Shell>} />
          <Route path="/admin/integrations" element={<Shell module="settings"><IntegrationsAdmin /></Shell>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
